import React, { useEffect, useMemo, useState } from "react";
import { v4 as uuid } from "uuid";
import { IoIosArrowDropdown } from "react-icons/io";
import "./addnewclient.css";
import Select from "react-select";
import { TiDeleteOutline } from "react-icons/ti";
import { Table, Button } from "react-bootstrap";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { IoIosAddCircleOutline } from "react-icons/io";
import CreatableSelect from "react-select/creatable";
import axiosinstances, { baseURL } from "../../Helper/useAxios";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
// import { isaddUpdateMerchant } from "../../redux/addupdate/action";
import UILoader from "../../utils/comman/loader";
import {
  dangerColor,
  extractUniqueAccNamesAndVPAsForwhitelistMid,
  stylesofStyleWithColor,
  stylesofStype,
} from "../../utils/comman/Common";
import { checkActive, PAYIN, PAYOUT } from "../../utils/Constant";
import BubbleWithNumber from "../../utils/Bubble";

const ENABLE = "ENABLE";
const CHECKBOX = "CHECKBOX";
const API = "API";
const P2P = "P2P";
const ENABLE_PAYOUT_MENUAL_OPTIONS = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];
export default function MerchantProfile() {
  //REACT_APP_REDIRECT_TYPE
  const isResellar = useSelector((state) => state.authReducer?.isResellar);
  const redirectTypeOPTIOSJSONS = process.env.REACT_APP_REDIRECT_TYPE;
  const REDIRECTJSONS = JSON.parse(redirectTypeOPTIOSJSONS);
  const txnMethodOPTIOSJSONS = process.env.REACT_APP_TXN_METHOD;
  const TXNMETHODJSONS = JSON.parse(txnMethodOPTIOSJSONS);
  const optionsListOfResellar = useSelector(
    (state) => state.listOfallResellarReducer?.LIST
  );
  const defaultReseller = { label: "NONE", value: "NONE" };
  //const RESELLEROPTIONS = [defaultReseller, optionsListOfResellar];
  const navigate = useNavigate();
  const locations = useLocation();
  const dispatch = useDispatch();
  const isUpdate = true;

  // const data = {};

  const id = useSelector((state) => state.getprofilereducer?.getprofile?.id);

  const e = JSON.parse(sessionStorage.getItem("token"));
  const sessionId = useSelector(
    (state) => state.getprofilereducer?.getprofile?.sessionId
  );
  const reqId = useSelector(
    (state) => state.getprofilereducer?.getprofile?.requestId
  );
  const headers = {
    Authorization: `Bearer ${e}`,
    "client-id": sessionId,
    "request-id": reqId,
  };
  const [data, setData] = useState({});
  const [backlistCount, setBacklistCount] = useState([]);
  const [Isloader, setIsLoader] = useState(false);
  const userIp = useSelector((state) => state.userIpAddReducer.ip);
  const latitude = useSelector((state) => state.userIpAddReducer.latitude);
  const longitude = useSelector((state) => state.userIpAddReducer.longitude);
  const [axiosInstance] = axiosinstances(userIp, latitude, longitude);
  const mid = JSON.parse(sessionStorage.getItem("mid"));
  const [selectedRedirectType, setSelectedRedirectType] = useState({
    label: "",
    value: "",
  });
  const [selectedTxnMethod, setSelectedTxnMethod] = useState({
    label: "NORMAL",
    value: "NORMAL",
  });
  const [selectedReseller, setSelectedReseller] = useState({
    label: "NONE",
    value: "NONE",
  });
  const [selectedMenualPayout, setSelectedMenualPayout] = useState({
    label: "NONE",
    value: "NONE",
  });
  const [isCustomizedApi, setIsCustomizedApi] = useState(false);
  const [isCustomizedPtp, setIsCustomizedPtp] = useState(false);
  const [unAssignAccountOptions, setUnAssignAccounOptionst] = useState([]);
  const [assignAccountOptions, setAssignAccountOptions] = useState([]);
  const [unAssignAccountPayout, setUnAssignAccountPayout] = useState([]);
  const [unAssignAccountPayin, setUnAssignAccountPayin] = useState([]);
  const [assignAccountPayout, setAssignAccountPayout] = useState([]);
  const [assignAccountPayin, setAssignAccountPayin] = useState([]);
  const [assignAccountBankerPayout, setAssignAccountBankerPayout] = useState(
    []
  );
  const [assignAccountBankerPayin, setAssignAccountBankerPayin] = useState([]);
  const [
    assignAccountBankerPayoutwithCount,
    setAssignAccountBankerPayoutwithCount,
  ] = useState([]);
  const [
    assignAccountBankerPayinwithCount,
    setAssignAccountBankerPayinwithCount,
  ] = useState([]);
  const [assignOriginalAccount, setAssignOriginalAccount] = useState([]);
  const [payinAssingnOptions, setPayinAssingnOptions] = useState([]);
  const [payoutAssingnOptions, setPayoutAssingnOptions] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [payinAssignOptionsForBanker, setPayinAssignOptionsForBanker] =
    useState([]);
  const [payoutAssignOptionsForBanker, setPayoutAssignOptionsForBanker] =
    useState([]);
  const [personalDetails, setPersonalDetails] = useState({
    name: "",
    alias: "",
    url: "",
    logo: "",
    contactName: "",
    contactMobile: "",
    contactEmail: "",
    dtAdd: "",
    dtNet: "",
    limit: "",
    minTicketSize: "",
    maxTicketSize: "",
    minTicketSizePayout: 0,
    maxTicketSizePayout: 0,
    payinReserve: "2",
    reserveDuration: 0,
    payinMdr: "",
    payoutMdr: "",
    dtMdr: "",
    manualPayout: false,
    // reseller:"NONE",
    redirectType: "",
    api: {
      minTicketSize: 500,
      maxTicketSize: 25000,
      enabled: false,
      weight: 1,
    },
    p2p: {
      minTicketSize: 500,
      maxTicketSize: 25000,
      enabled: false,
      weight: 1,
    },
  });

  const [newVPA, setNewVPA] = useState("");
  const [expiryHours, setExpiryHours] = useState(0);
  const [expiryMinutes, setExpiryMinutes] = useState(30);
  const [isaddVpa, setIsAddVpa] = useState(false);

  const [blacklist, setBlacklist] = useState([]);

  console.log("selectedMenualPayout", selectedMenualPayout);
  console.log("assignAccountPayout", assignAccountPayout);
  console.log("assignAccountPayin12", assignAccountPayin);
  console.log("unAssignAccountPayout", unAssignAccountPayout);
  console.log("unAssignAccountPayin1", unAssignAccountPayin);
  console.log("selectedTxnMethod", selectedTxnMethod);
  console.log("Assingn Options for add account in payin", payinAssingnOptions);
  console.log(
    "Assingn Options for add account in payout",
    payoutAssingnOptions
  );
  console.log("payinAssignOptionsForBanker", payinAssignOptionsForBanker);
  console.log("payoutAssignOptionsForBanker", payoutAssignOptionsForBanker);
  console.log(
    "assignAccountBankerPayin",
    assignAccountBankerPayin,
    assignAccountBankerPayout
  );

  console.log(
    "assignAccountBankerPayinwithCount",
    assignAccountBankerPayinwithCount
  );
  const addTime = (hours, minutes) => {
    return moment()
      .add(hours || 0, "hours") // Ensure hours is always a number
      .add(minutes || 0, "minutes") // Ensure minutes is always a number
      .format("YYYY-MM-DDTHH:mm:ss");
  };
  // Action handlers

  const addBlacklistVPA = () => {
    if (!newVPA) {
      toast.warn("Enter VPA");
      return;
    }
    function isValidVPA(vpa) {
      const vpaRegex = /^.{2,}@.{2,}$/;
      return vpaRegex.test(vpa);
    }

    if (!isValidVPA(newVPA)) {
      toast.warn("enter vpa is not correct");
      return;
    }
    console.log("isValidVPA", isValidVPA(newVPA));
    if (blacklist.some((item) => item.vpa === newVPA)) {
      toast.warn("VPA already exists in blacklist");
      return;
    }

    const newEntry = {
      vpa: newVPA,
      byUser: id,
      addedOn: moment().format("YYYY-MM-DDTHH:mm:ss"), // Fix: Use ISO 8601
      expireOn: addTime(expiryHours, expiryMinutes),
    };

    setBlacklist((prev) => [newEntry, ...prev]);
    setNewVPA("");
  };
  const expireVPA = (vpa) => {
    setBacklistCount((pre) => [...pre, vpa]);
    setBlacklist((prev) =>
      prev.map((item) =>
        item.vpa === vpa
          ? {
              ...item,
              expireOn: moment().format("YYYY-MM-DDTHH:mm:ss"),
              byUser: `${item.byUser}/${id}`,
            }
          : item
      )
    );
  };
  // const addBackListHandler = () => {
  //   if (!newVPA || !expiryMinutes) {
  //     toast.warn("Enter required fields like VPA and time");
  //     return;
  //   }
  //   const isVpaExists = blacKlistVpaList.some((item) => item.vpa === newVPA);
  //   if (isVpaExists) {
  //     toast.warn("VPA already exists in the blacklist");
  //     return;
  //   }
  //   const newVpa = {
  //     vpa: newVPA,
  //     byUser: id,
  //     addedOn: moment().format("YYYY-MM-DD HH:mm"),
  //     expireOn: addTime(Number(expiryHours) || 0, Number(expiryMinutes)),
  //   };

  //   setBlacKlistVpaList((prev) => [...prev, newVpa]);
  // };
  const handleEdit = (id) => {
    console.log(`Edit user with ID: ${id}`);
  };

  const handleDelete = (id) => {
    console.log(`Delete user with ID: ${id}`);
  };
  const fetchMerchantDetails = async (mid) => {
    let url = `/api/v1/upi/merchant/get?id=${mid}`;

    const response = await axiosInstance
      .get(
        url,

        {
          headers,
        }
      )
      .then((res) => {
        setData(res.data);
        const sortedBlacklist =
          Array.isArray(res.data?.blacklist) &&
          res.data?.blacklist.length > 0 &&
          res.data?.blacklist.sort((a, b) => {
            return (
              new Date(b.expireOn).getTime() - new Date(a.expireOn).getTime()
            );
          });
        setBlacklist(sortedBlacklist || []);
      })
      .catch((err) => {
        toast.error("Something went wrong");
      });
  };
  useEffect(() => {
    fetchMerchantDetails(mid);
    setBacklistCount([]);
  }, []);

  const saveBlacklist = async (e) => {
    e.preventDefault();
    const isAdmin = false;
    try {
      let url = `/api/v1/upi/merchant/get?id=${mid}`;
      const { data: latestMerchant } = await axiosInstance.get(url, {
        headers,
      });
      // Merges blacklist with latestMerchant.blacklist
      // Ensures uniqueness using vpa
      // Keeps expired vpa if it exists in latestMerchant.blacklist
      // Uses moment for expiry check
      // const mergedBlacklist = isAdmin
      //   ? Array.from(
      //       new Map(
      //         [...blacklist, ...latestMerchant.blacklist]
      //           .filter((obj) => {
      //             const merchantObj = latestMerchant.blacklist.find(
      //               (merchantVpa) => merchantVpa.vpa === obj.vpa
      //             );
      //             return (
      //               !merchantObj ||
      //               moment(merchantObj.expireOn).isBefore(moment())
      //             ); // Keep if expired
      //           })
      //           .map((obj) => [obj.vpa, obj]) // Ensure uniqueness
      //       ).values()
      //     )
      //   : Array.from(
      //       new Map(
      //         [...latestMerchant.blacklist, ...blacklist]
      //           .filter((obj) => {
      //             const merchantObj = latestMerchant.blacklist.find(
      //               (merchantVpa) => merchantVpa.vpa === obj.vpa
      //             );
      //             return (
      //               !merchantObj ||
      //               moment(merchantObj.expireOn).isBefore(moment())
      //             ); // Keep if expired
      //           })
      //           .map((obj) => [obj.vpa, obj]) // Ensure uniqueness
      //       ).values()
      //     );
      const mergedBlacklist = isAdmin
        ? Array.from(
            new Map(
              [...blacklist, ...latestMerchant.blacklist].map((obj) => [
                obj.vpa,
                obj,
              ])
            ).values()
          )
        : Array.from(
            new Map(
              [...latestMerchant.blacklist, ...blacklist].map((obj) => [
                obj.vpa,
                obj,
              ])
            ).values()
          );

      const updatedMerchant = { ...latestMerchant, blacklist: mergedBlacklist };

      const res = await axiosInstance.post(
        isAdmin
          ? "/api/v1/upi/merchant/update"
          : "/api/v1/upi/merchant/update/blacklist",
        updatedMerchant,
        { headers }
      );

      if (res.status == 200) {
        toast.success("Blacklist updated successfully");
        fetchMerchantDetails(mid);
        setBacklistCount([]);
      } else {
        toast.error("Error updating blacklist");
      }

      // fetchMerchant();
    } catch (error) {
      toast.error("Error updating blacklist");
    }
  };

  // Handler to update the state when the switch is toggled
  // function extractUniqueAccNamesAndVPAs(accounts, type, checkStatus) {
  //   const accMap = {};

  //   accounts.forEach((account) => {
  //     const { bankerId, vpa } = account;
  //     if (account?.type === type) {
  //       if (!accMap[bankerId]) {
  //         accMap[bankerId] = []; // Initialize an array for new bankerId
  //       }
  //       let check = checkActive(account) ? "active" : "inactive";
  //       accMap[bankerId].push(vpa); // Add the vpa to the accName's array
  //       accMap["status"] = check;
  //     }
  //   });

  //   // Convert the accMap object into an array of objects
  //   return Object.entries(accMap).map(([bankerId, vpas]) => ({
  //     bankerId,
  //     vpa: vpas,
  //   }));
  // }
  function extractUniqueAccNamesAndVPAs(accounts, type, checkStatus) {
    const accMap = {};

    accounts.forEach((account) => {
      const { bankerId, id } = account;

      if (account?.type === type) {
        if (!accMap[bankerId]) {
          // Initialize the object based on checkStatus
          if (checkStatus) {
            accMap[bankerId] = { id: [], status: "" }; // Include status
          } else {
            accMap[bankerId] = { id: [] }; // No status field
          }
        }

        // Set the status only if it's not already set to "active"
        if (
          checkStatus &&
          (accMap[bankerId].status === "" ||
            accMap[bankerId].status === "inactive")
        ) {
          let status = checkActive(account) ? "active" : "inactive";
          accMap[bankerId].status = status; // Add status to the bankerId object
        }

        // Ensure id is unique before adding
        if (!accMap[bankerId].id.includes(id)) {
          accMap[bankerId].id.push(id);
        }
      }
    });

    // Convert the accMap object into an array of objects
    return Object.entries(accMap).map(([bankerId, { id, status }]) => {
      const result = { bankerId, id };
      if (checkStatus) {
        result.status = status; // Only add status if checkStatus is true
      }
      return result;
    });
  }

  useEffect(() => {
    if (
      Array.isArray(assignAccountBankerPayin) &&
      assignAccountBankerPayin.length > 0
    ) {
      const result = assignAccountBankerPayin.map((val) => {
        console.log("resultccc1", val);
        if (val?.length) {
          var labelWithLength = `${val?.label} (${val?.length})`;
        } else {
          var labelWithLength = `${val?.label}`;
        }

        return {
          label: labelWithLength,
          value: val?.value,
          status: val.status,
        };
      });
      console.log("resultccc", result);
      setAssignAccountBankerPayinwithCount(result); // Ensure this is uncommented and properly defined
    } else if (
      Array.isArray(assignAccountBankerPayin) &&
      assignAccountBankerPayin.length == 0
    ) {
      setAssignAccountBankerPayinwithCount([]);
    }
  }, [assignAccountBankerPayin]);

  useEffect(() => {
    if (
      Array.isArray(assignAccountBankerPayout) &&
      assignAccountBankerPayout.length > 0
    ) {
      const result = assignAccountBankerPayout.map((val) => {
        if (val?.length) {
          var labelWithLength = `${val?.label} (${val?.length})`;
        } else {
          var labelWithLength = `${val?.label}`;
        }

        return {
          label: labelWithLength,
          value: val?.value,
          status: val.status,
        };
      });

      setAssignAccountBankerPayoutwithCount(result); // Ensure this is uncommented and properly defined
    } else if (
      Array.isArray(assignAccountBankerPayout) &&
      assignAccountBankerPayout.length == 0
    ) {
      setAssignAccountBankerPayoutwithCount([]);
    }
  }, [assignAccountBankerPayout]);

  const handleSwitchChange = (event) => {
    console.log("CALLED", event.target.checked);
    setIsChecked(event.target.checked); // Update the state with the new checkbox value
  };
  // useEffect(() => {
  //   if (Array.isArray(accountList) && accountList.length > 0) {
  //     // Prepare lists for pay-in and pay-out
  //     const payinAccList = [];
  //     const payoutAccList = [];

  //     for (let i = 0; i < accountList.length; i++) {
  //       const Bname = accountList[i].bank.toUpperCase();
  //       const nameAndBName = `${accountList[i].accName} - ${Bname}`;
  //       const accLabel = {
  //         label: nameAndBName,
  //         value: accountList[i].id,
  //       };

  //       // Categorize accounts
  //       if (accountList[i].type === PAYIN) {
  //         payinAccList.push(accLabel);
  //       }
  //       if (accountList[i].type === PAYOUT) {
  //         payoutAccList.push(accLabel);
  //       }
  //     }
  //     console.log("total payin acc list", payinAccList);
  //     console.log("total payout acc list", payoutAccList);
  //     // Filter unassigned accounts outside the loop
  //     const payInResult = payinAccList.filter(
  //       (item) =>
  //         !unAssignAccountPayin.some((other) => other.value === item.value) &&
  //         !assignAccountPayin.some((other) => other.value === item.value)
  //     );
  //     const payOutResult = payoutAccList.filter(
  //       (item) =>
  //         !unAssignAccountPayout.some((other) => other.value === item.value) &&
  //         !assignAccountPayout.some((other) => other.value === item.value)
  //     );

  //     // Set options
  //     setPayinAssingnOptions(payInResult);
  //     setPayoutAssingnOptions(payOutResult);
  //   }
  // }, [
  //   accountList,
  //   unAssignAccountPayin,
  //   assignAccountPayin,
  //   unAssignAccountPayout,
  //   assignAccountPayout,
  // ]);

  // useEffect(() => {
  //   if (Array.isArray(accountList) && accountList.length > 0) {
  //     let datapayin = extractUniqueAccNamesAndVPAs(accountList, "PAYIN", true);
  //     let datapayout = extractUniqueAccNamesAndVPAs(
  //       accountList,
  //       "PAYOUT",
  //       true
  //     );
  //     console.log("testpayin", datapayin, datapayout);
  //     console.log("testpayin1", assignAccountBankerPayin);
  //     // if (isBanker) {
  //     //   data = data.filter((v) => v.bankerId === bankerId);
  //     // }
  //     // if (isDistributor) {
  //     //   data = data.filter((v) => allIDBankerOfDistAdmin.includes(v.bankerId));
  //     // }
  //     const payInResult = datapayin.filter(
  //       (item) => !datapayin.some((other) => other.bankerId == item.label)
  //       // && !assignAccountPayout.some((other) => other.value === item.value)
  //     );
  //     function removeMatchingItems(a1, a2) {
  //       // Iterate through a2 and check for matching bankerId in a1
  //       a2.forEach(({ label }) => {
  //         console.log("abc1112", a1, a2);
  //         const index = a1.findIndex((item) => item.bankerId === label);

  //         if (index !== -1) {
  //           // Remove the matching item from a1
  //           a1.splice(index, 1);
  //         }
  //       });

  //       // Return the updated a1 containing only the remaining items
  //       const finala1 = a1.map((val) => {
  //         const labelWithLength = `${val?.bankerId} (${val.id.length})`;
  //         const accLabel = {
  //           label: labelWithLength,
  //           value: val?.id.join(","),
  //           status: val.status,
  //         };
  //         return accLabel;
  //       });
  //       return finala1;
  //     }

  //     const removedPayin = removeMatchingItems(
  //       datapayin,
  //       assignAccountBankerPayin
  //     );
  //     const removedPayout = removeMatchingItems(
  //       datapayout,
  //       assignAccountBankerPayout
  //     );
  //     console.log("testpayinremoved", removedPayin, removedPayout);
  //     console.log("testpayin2", payInResult);
  //     setPayinAssignOptionsForBanker(removedPayin); // Update state with processed data
  //     setPayoutAssignOptionsForBanker(removedPayout);
  //   } else {
  //     setPayinAssignOptionsForBanker([]); // Reset to empty array if accountList is invalid or empty
  //     setPayoutAssignOptionsForBanker([]);
  //   }
  // }, [
  //   accountList,
  //   isChecked,
  //   assignAccountBankerPayin,
  //   assignAccountBankerPayout,
  // ]); // Dependencies: update when these change

  const fetchWhiteListedAccountLists = async (mid) => {
    let url = `/api/v1/upi/account/get/usable/${mid}`;

    const response = await axiosInstance
      .post(
        url,
        {},
        {
          headers,
        }
      )
      .then((res) => {
        let unassignAccpayout = [];
        let unassignAccpayin = [];
        let orignalAcc = [];
        let assignAccPayout = [];
        let assignAccPayin = [];

        if (res.data.length > 0) {
          let payinassignedBanker = extractUniqueAccNamesAndVPAsForwhitelistMid(
            res.data,
            "PAYIN",
            true
          );
          let payoutassignedBanker =
            extractUniqueAccNamesAndVPAsForwhitelistMid(
              res.data,
              "PAYOUT",
              true
            );

          if (
            Array.isArray(payinassignedBanker) &&
            payinassignedBanker.length > 0
          ) {
            const updatedpayinassignedBanker = payinassignedBanker.map(
              (val) => {
                const length = val?.id.length;
                const accLabel = {
                  label: val?.bankerId,
                  value: val?.id.join(","),
                  status: val?.status,
                  length: length,
                };
                return accLabel;
              }
            );
            console.log(
              "updatedpayinassignedBanker",
              updatedpayinassignedBanker
            );
            setAssignAccountBankerPayin(updatedpayinassignedBanker);
          }
          if (
            Array.isArray(payoutassignedBanker) &&
            payoutassignedBanker.length > 0
          ) {
            const updatedpayoutassignedBanker = payoutassignedBanker.map(
              (val) => {
                const length = val?.id.length;
                const accLabel = {
                  label: val?.bankerId,
                  value: val?.id.join(","),
                  status: val?.status,
                  length: length,
                };
                return accLabel;
              }
            );
            console.log(
              "updatedpayoutassignedBanker",
              updatedpayoutassignedBanker
            );
            setAssignAccountBankerPayout(updatedpayoutassignedBanker);
          }
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].whitelistMid.length > 0) {
              orignalAcc.push(res.data[i].id);
            }
            if (
              res.data[i].whitelistMid.length > 0 &&
              res.data[i].type == "PAYIN"
            ) {
              const Bname = res.data[i].bank.toUpperCase();
              console.log("res.data[i]", res.data[i]);

              const nameAndbame = `${res.data[i].accName} - ${Bname}`;
              const accLabel = {
                label: nameAndbame,
                value: res.data[i].id,
                status: checkActive(res.data[i]) ? "active" : "inactive",
              };
              assignAccPayin.push(accLabel);
            }
            if (
              res.data[i].whitelistMid.length > 0 &&
              res.data[i].type == "PAYOUT"
            ) {
              const Bname = res.data[i].bank.toUpperCase();

              const nameAndbame = `${res.data[i].accName} - ${Bname}`;
              const accLabel = {
                label: nameAndbame,
                value: res.data[i].id,
                status: checkActive(res.data[i]) ? "active" : "inactive",
              };
              assignAccPayout.push(accLabel);
            }
            if (
              res.data[i].whitelistMid.length == 0 &&
              res.data[i].type == "PAYIN"
            ) {
              const Bname = res.data[i].bank.toUpperCase();

              const nameAndbame = `${res.data[i].accName} - ${Bname}`;
              const accLabel = {
                label: nameAndbame,
                value: res.data[i].id,
                status: checkActive(res.data[i]) ? "active" : "inactive",
              };
              unassignAccpayin.push(accLabel);
            }
            if (
              res.data[i].whitelistMid.length == 0 &&
              res.data[i].type == "PAYOUT"
            ) {
              const Bname = res.data[i].bank.toUpperCase();

              const nameAndbame = `${res.data[i].accName} - ${Bname}`;
              const accLabel = {
                label: nameAndbame,
                value: res.data[i].id,
                status: checkActive(res.data[i]) ? "active" : "inactive",
              };
              unassignAccpayout.push(accLabel);
            }
            setAssignOriginalAccount(orignalAcc);

            setUnAssignAccountPayout(unassignAccpayout);
            setUnAssignAccountPayin(unassignAccpayin);
            setAssignAccountPayout(assignAccPayout);
            setAssignAccountPayin(assignAccPayin);
          }
          console.log("aaaaa1", payinassignedBanker, assignAccPayin);
          console.log("aaaaa2", payoutassignedBanker, assignAccPayout);
        }
        console.log("response", res);
      })
      .catch((err) => {
        toast.error("Something went wrong");
      });
    if (response) {
      const result = response.data.orders;

      if (result) {
      }

      return response.data;
    }
    return false;
  };

  const merchantChangeHandlePayout = (select) => {
    if (!isChecked) {
      setAssignAccountPayout(select);
    } else {
      setAssignAccountBankerPayout(select);
    }
  };
  const merchantChangeHandlePayin = (select) => {
    console.log("select1", select);
    if (!isChecked) {
      setAssignAccountPayin(select);
    } else {
      setAssignAccountBankerPayin(select);
    }
  };

  useEffect(() => {
    if (isUpdate) {
      setPersonalDetails(data);
      console.log("data1", data);
      fetchWhiteListedAccountLists(data?.id);
      if (data?.redirectType !== undefined && data?.redirectType !== "") {
        setSelectedRedirectType({
          label: data?.redirectType,
          value: data?.redirectType,
        });
        setSelectedTxnMethod({
          label: data?.flowType,
          value: data?.flowType,
        });
      }
      if (data?.reseller !== undefined && data?.reseller !== "") {
        setSelectedReseller({ label: data?.reseller, value: data?.reseller });
      }
      if (data?.manualPayout !== undefined) {
        if (data?.manualPayout) {
          setSelectedMenualPayout({ label: "Yes", value: data?.manualPayout });
        } else if (!data?.manualPayout) {
          setSelectedMenualPayout({ label: "No", value: data?.manualPayout });
        }
      }
    }
  }, [data, isUpdate]);
  const RESELLEROPTIONS = useMemo(() => {
    const value = () => {
      if (
        Array.isArray(optionsListOfResellar) &&
        optionsListOfResellar.length > 0
      ) {
        let data = optionsListOfResellar.map((val) => ({
          label: val,
          value: val,
        }));
        data = [defaultReseller, ...data];
        return data;
      } else return [defaultReseller];
    };
    return value();
  }, [optionsListOfResellar]);
  const isValidEmail = (email) => {
    // Regular expression for basic email validation
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  };
  console.log("selectedReseller", selectedReseller);
  const handleCheckboxChange = (e, val) => {
    if (val === API) {
      setIsCustomizedApi(!isCustomizedApi);
    }
    if (val === P2P) {
      setIsCustomizedPtp(!isCustomizedPtp);
    }
  };
  //manualPayoutHandler
  const manualPayoutHandler = (inputValue) => {
    setSelectedMenualPayout(inputValue);
  };
  const resellerHandler = (inputValue) => {
    console.log("inputValue", inputValue);
    const isSpace = inputValue.value.includes(" ");
    if (inputValue.__isNew__ && isSpace) {
      const formattedValue = inputValue?.value.replace(/ /g, "_").toUpperCase();
      const newOption = {
        label: formattedValue,
        value: formattedValue,
      };
      setSelectedReseller(newOption);
    } else if (inputValue.__isNew__ && !isSpace) {
      const formattedValue = inputValue?.value.toUpperCase();
      const newOption = {
        label: formattedValue,
        value: formattedValue,
      };
      setSelectedReseller(newOption);
    } else {
      setSelectedReseller(inputValue);
    }
  };
  const handlerInfoChange = (e, enable, checkbox) => {
    const { name, value } = e.target;
    let inputValue = value;
    if (enable === ENABLE) {
      const updatedDetails = { ...personalDetails };

      if (checkbox == CHECKBOX) {
        if (name === "api.enabled") {
          // console.log("e.target", e.target.checked);
          setPersonalDetails({
            ...personalDetails,
            api: {
              ...personalDetails.api,
              enabled: e.target.checked, // Update the enabled property based on the checkbox state
            },
          });
          return;
        }
        if (name === "p2p.enabled") {
          setPersonalDetails({
            ...personalDetails,
            p2p: {
              ...personalDetails.p2p,
              enabled: e.target.checked, // Update the enabled property based on the checkbox state
            },
          });
        }
        return;
      } else {
        const nameParts = name.split(".");
        let currentObj = updatedDetails;

        for (let i = 0; i < nameParts.length - 1; i++) {
          currentObj = currentObj[nameParts[i]];
        }

        currentObj[nameParts[nameParts.length - 1]] = value;
      }

      setPersonalDetails(updatedDetails);
      return;
    } else {
      if (name === "contactMobile") {
        // Remove non-numeric characters and limit to 10 digits
        inputValue = value.replace(/\D/g, "").slice(0, 10);
      } else if (name === "email") {
        // Validate email format
        inputValue = value.toLowerCase().trim(); // Convert to lowercase and remove leading/trailing spaces
        // You can use a regular expression for email validation
        // This is a simple example, actual email validation can be more complex
        if (value.trim() && !isValidEmail(value)) {
          // If email is not valid, you can choose to handle it accordingly (e.g., show error message)
          console.log("Invalid email format");
          return; // Do not update state for invalid email format
        }
      }
      // console.log('name', name, inputValue)
      setPersonalDetails({
        ...personalDetails,
        [name]: inputValue,
      });
      return;
    }
  };
  //console.log("personalDetails", personalDetails);
  useEffect(() => {
    if (selectedRedirectType !== null && selectedRedirectType.value !== "") {
      setPersonalDetails({
        ...personalDetails,
        redirectType: selectedRedirectType?.value,
      });
    }
  }, [selectedRedirectType]);
  useEffect(() => {
    // if (!isUpdate) {
    if (selectedTxnMethod?.value) {
      setPersonalDetails((prevDetails) => ({
        ...prevDetails,
        flowType: selectedTxnMethod.value,
      }));
    }
    // }
  }, [selectedTxnMethod]);
  useEffect(() => {
    if (selectedReseller !== null && selectedReseller.value !== "NONE") {
      setPersonalDetails({
        ...personalDetails,
        reseller: selectedReseller?.value,
      });
    }
  }, [selectedReseller]);

  useEffect(() => {
    if (
      selectedMenualPayout !== null &&
      selectedMenualPayout.value !== "NONE"
    ) {
      setPersonalDetails({
        ...personalDetails,
        manualPayout: selectedMenualPayout?.value,
      });
    }
  }, [selectedMenualPayout]);

  const UpdateAcc = async () => {
    const API_ENDPOINT = "/api/v1/upi/merchant/update";

    try {
      let requestPayload = {
        ...personalDetails,
      };
      requestPayload.minTicketSizePayout = parseInt(
        requestPayload.minTicketSizePayout
      );
      requestPayload.maxTicketSizePayout = parseInt(
        requestPayload.maxTicketSizePayout
      );
      //reserveDuration
      requestPayload.reserveDuration = parseInt(requestPayload.reserveDuration);

      const response = await axiosInstance.post(API_ENDPOINT, requestPayload, {
        headers,
      });

      if (response.status === 200 && response?.data?.name !== undefined) {
        // console.log("response", response);
        toast.success(`Updated Merchant details ${response?.data?.name}`);
        navigate("/dashboard");
      } else {
        // console.log("res", response);
        throw new Error(response?.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);

      toast.error(error?.message);
      return false;
    }
  };
  function convertToArray(commaSeparatedString) {
    return commaSeparatedString.split(",").map((item) => item.trim());
  }
  function makeKeysUnique(array) {
    return [...new Set(array)];
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isUpdate) {
      // const newAccList = assignAccount.map((val) => val.value);
      let newAccList = [];
      const newAccList1 = assignAccountPayin.concat(assignAccountPayout);

      if (!isChecked) {
        newAccList = newAccList1.map((val) => val.value);
      } else {
        // assignAccountBankerPayout
        function getCommaSeparatedValues(dataArray) {
          return dataArray.map((item) => item.value).join(",");
        }
        const allPayinIncommaSeperated = getCommaSeparatedValues(
          assignAccountBankerPayin
        );
        console.log("test12", allPayinIncommaSeperated);
        const arrayPayin = convertToArray(allPayinIncommaSeperated);
        const allPayoutIncommaSeperated = getCommaSeparatedValues(
          assignAccountBankerPayout
        );
        const arrayPayout = convertToArray(allPayoutIncommaSeperated);
        console.log("test13", allPayoutIncommaSeperated);
        newAccList = arrayPayin.concat(arrayPayout);
        // console.log("test14", combine);

        // console.log("test15", array);
        // newAccList = makeKeysUnique(combine);
        // console.log("uniqueArray", uniqueArray);
        // console.log("test16", array);
      }
      function symmetricDifference(arr1, arr2) {
        const diff1 = arr1.filter((item) => !arr2.includes(item));
        const diff2 = arr2.filter((item) => !arr1.includes(item));
        return [...diff1, ...diff2];
      }
      console.log("newAccList", newAccList.join(","), assignOriginalAccount);
      console.log(
        "diffrence of array",
        symmetricDifference(newAccList, assignOriginalAccount)
      );
      const filteredArray = newAccList.filter((item) => item !== "");
      const newOrignalList =
        assignOriginalAccount.length > 0
          ? assignOriginalAccount.join(",")
          : "NA";
      const finalNewAccList =
        filteredArray.length > 0 ? filteredArray.join(",") : "NA";

      if (finalNewAccList || newOrignalList) {
        const UPDATE_ACC_LIST_URL = `/api/v1/upi/account/update/usable/${data?.id}/${newOrignalList}/${finalNewAccList}`;
        const UPDATE_ACC_REQUEST = {};

        try {
          const response = await axiosInstance.post(
            UPDATE_ACC_LIST_URL,
            UPDATE_ACC_REQUEST,
            {
              headers,
            }
          );

          if (response.status === 200) {
            UpdateAcc();
          } else {
            // console.log("res", response);
            throw new Error(response?.message);
          }
        } catch (error) {
          console.error("Error fetching data:", error);

          toast.error(error?.message);
          return false;
        }
      } else {
        UpdateAcc();
      }
    } else {
      const API_ENDPOINT = "/api/v1/upi/merchant/add";
      try {
        let requestPayload = {
          ...personalDetails,
        };
        requestPayload.minTicketSizePayout = parseInt(
          requestPayload.minTicketSizePayout
        );
        requestPayload.maxTicketSizePayout = parseInt(
          requestPayload.maxTicketSizePayout
        );
        //reserveDuration
        requestPayload.reserveDuration = parseInt(
          requestPayload.reserveDuration
        );
        const response = await axiosInstance.post(
          API_ENDPOINT,
          requestPayload,
          {
            headers,
          }
        );

        if (response.status === 200 && response?.data?.name !== undefined) {
          // console.log("response", response);

          toast.success(`Added New Merchant ${response?.data?.name}`);

          navigate("/dashboard");
          // return data;
        } else {
          // console.log("res", response);
          throw new Error(response?.response?.data?.message || response?.error);
        }
      } catch (error) {
        console.error("Error fetching data:", error);

        toast.error(error?.message);
        return false;
      }
    }
  };
  const copyAccountDetailsForAddNewAccount = () => {
    setIsLoader(true);
    let updatedData = { ...personalDetails };
    updatedData?.id !== undefined && delete updatedData.id;
    updatedData.name = `${personalDetails.name} copy`;
    updatedData.alias = `${personalDetails.alias} copy`;
    setTimeout(() => {
      setIsLoader(false);
    }, 300);
    setPersonalDetails(updatedData);
    // dispatch(isaddUpdateMerchant(false));
    toast.success("Merchant copied");
  };

  const goback = () => {
    // dispatch(isaddUpdateMerchant(false));
    navigate("/dashboard");
  };
  //<UILoader />
  console.log("personalDetails", personalDetails);
  return (
    <>
      {Isloader ? (
        <UILoader />
      ) : (
        <div class="mid-contant">
          <div class="container">
            <div class="row">
              <div class="col-12">
                <div class="head">
                  {isUpdate ? (
                    <h2>Update merchant</h2>
                  ) : (
                    <h2>Register as a merchant</h2>
                  )}
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="registerbox">
                    <div class="row mb-3">
                      <div class="col-12 col-lg-12">
                        <form onSubmit={(e) => saveBlacklist(e)}>
                          <div class="row">
                            <div style={{ marginTop: "0px" }} class="separator">
                              <span class="separator_text">
                                Merchant Details
                              </span>
                            </div>
                            <div id="add_account_color" class="col-12 col-md-4">
                              <div class="form-floating">
                                <input
                                  disabled
                                  required
                                  type="text"
                                  class="form-control"
                                  id="alias"
                                  name="alias"
                                  onChange={(e) => handlerInfoChange(e)}
                                  value={personalDetails?.alias}
                                  placeholder="Enter alias"
                                />
                                <label for="alias">Alias</label>
                              </div>
                            </div>
                            <div id="add_account_color" class="col-12 col-md-4">
                              <div class="form-floating">
                                <input
                                  required
                                  disabled
                                  type="text"
                                  class="form-control"
                                  id="name"
                                  name="name"
                                  onChange={(e) => handlerInfoChange(e)}
                                  value={personalDetails?.name}
                                  placeholder="Enter first name"
                                />
                                <label for="name">Name</label>
                              </div>
                            </div>
                            <div id="add_account_color" class="col-12 col-md-4">
                              <div class="form-floating">
                                <input
                                  type="text"
                                  disabled
                                  class="form-control"
                                  id="firsname"
                                  name="contactName"
                                  onChange={(e) => handlerInfoChange(e)}
                                  value={personalDetails?.contactName}
                                  placeholder="Enter first name"
                                />
                                <label for="firsname">Contact Name</label>
                              </div>
                            </div>
                            <div id="add_account_color" class="col-12 col-md-4">
                              <div class="form-floating">
                                {/* <input type="tel" pattern="[0-9]{10}" class="form-control" id="mobile" maxLength={10} placeholder="Enter mobile no." name='contactMobile' onChange={(e)=>handlerInfoChange()} value={personalDetails?.contactMobile}/> */}
                                <input
                                  type="tel"
                                  disabled
                                  pattern="[0-9]{10}"
                                  className="form-control"
                                  id="mobile"
                                  maxLength={10}
                                  placeholder="Enter mobile no."
                                  name="contactMobile"
                                  onChange={handlerInfoChange}
                                  value={personalDetails?.contactMobile}
                                  required
                                />
                                <label for="mobile">Mobile number</label>

                                {/* {personalDetails.contactMobile.length > 1 && isMobileCorrect &&	<small style={{color:'red'}} >Enter Valid Mobile Number</small>} */}
                              </div>
                            </div>
                            <div id="add_account_color" class="col-12 col-md-4">
                              <div class="form-floating">
                                <input
                                  required
                                  disabled
                                  type="email"
                                  class="form-control"
                                  id="email"
                                  placeholder="Enter email id"
                                  name="contactEmail"
                                  onChange={(e) => handlerInfoChange(e)}
                                  value={personalDetails?.contactEmail}
                                />
                                <label for="email">Email ID</label>
                                {/* { personalDetails.contactEmail.length > 3 && isEmailCorrect &&	<small style={{color:'red'}} >Enter Valid Email id</small>} */}
                              </div>
                            </div>

                            <div id="add_account_color" class="col-12 col-md-4">
                              <div class="form-floating">
                                <input
                                  required
                                  disabled
                                  type="text"
                                  class="form-control"
                                  id="logo"
                                  name="logo"
                                  onChange={(e) => handlerInfoChange(e)}
                                  value={personalDetails?.logo}
                                  placeholder="Enter logo"
                                />
                                <label for="logo">Logo</label>
                              </div>
                            </div>
                            <div
                              id="add_account_color"
                              class="col-12 col-md-12"
                            >
                              <div class="form-floating">
                                <input
                                  required
                                  disabled
                                  type="text"
                                  class="form-control"
                                  id="url"
                                  name="url"
                                  onChange={(e) => handlerInfoChange(e)}
                                  value={personalDetails?.url}
                                  placeholder="Enter Url"
                                />
                                <label for="url">URL</label>
                              </div>
                            </div>
                            <div
                              id="add_account_color"
                              className="col-12 col-md-6"
                            >
                              <div class="form-floating">
                                <CreatableSelect
                                  className="basic-multi-select form-control"
                                  isDisabled
                                  styles={stylesofStype}
                                  closeMenuOnSelect={true}
                                  components={{
                                    IndicatorsContainer: () => null,
                                    IndicatorSeparator: () => null,
                                  }}
                                  // isMulti
                                  options={RESELLEROPTIONS}
                                  onChange={(val) => resellerHandler(val)}
                                  value={selectedReseller}
                                  placeholder="Select Reseller"
                                />
                                <label>
                                  Reseller Name <IoIosArrowDropdown />
                                </label>
                              </div>
                            </div>
                            <div
                              id="add_account_color"
                              className="col-12 col-md-6"
                            >
                              <div class="form-floating">
                                <CreatableSelect
                                  isDisabled
                                  className="basic-multi-select form-control"
                                  styles={stylesofStype}
                                  closeMenuOnSelect={true}
                                  components={{
                                    IndicatorsContainer: () => null,
                                    IndicatorSeparator: () => null,
                                  }}
                                  // isMulti
                                  options={ENABLE_PAYOUT_MENUAL_OPTIONS}
                                  onChange={(val) => manualPayoutHandler(val)}
                                  value={selectedMenualPayout}
                                  placeholder="Select Manual Payout"
                                />
                                <label>
                                  Enable Manual Payout <IoIosArrowDropdown />
                                </label>
                              </div>
                            </div>
                            <div class="separator">
                              <span class="separator_text">Route Settings</span>
                            </div>
                            <div
                              id="add_account_color"
                              className="col-12 col-md-6"
                            >
                              <div class="form-floating">
                                <CreatableSelect
                                  isDisabled
                                  className="basic-multi-select form-control"
                                  styles={stylesofStype}
                                  closeMenuOnSelect={true}
                                  components={{
                                    IndicatorsContainer: () => null,
                                    IndicatorSeparator: () => null,
                                  }}
                                  // closeMenuOnSelect={true}
                                  // isMulti
                                  options={REDIRECTJSONS}
                                  onChange={(val) =>
                                    setSelectedRedirectType(val)
                                  }
                                  value={selectedRedirectType}
                                  placeholder="Select Redirect Type"
                                />
                                <label>
                                  Redirect Type <IoIosArrowDropdown />
                                </label>
                              </div>
                            </div>

                            <div
                              id="add_account_color"
                              className="col-12 col-md-6"
                            >
                              <div class="form-floating">
                                <CreatableSelect
                                  isDisabled
                                  className="basic-multi-select form-control"
                                  styles={stylesofStype}
                                  closeMenuOnSelect={true}
                                  components={{
                                    IndicatorsContainer: () => null,
                                    IndicatorSeparator: () => null,
                                  }}
                                  // closeMenuOnSelect={true}
                                  // isMulti
                                  options={TXNMETHODJSONS}
                                  onChange={(val) => setSelectedTxnMethod(val)}
                                  value={selectedTxnMethod}
                                  placeholder="Select TXN  Method"
                                />
                                <label>
                                  TXN Method <IoIosArrowDropdown />
                                </label>
                              </div>
                            </div>
                            <div class="separator">
                              <span class="separator_text">Limits</span>
                            </div>
                            <div id="add_account_color" class="col-12 col-md-4">
                              <div class="form-floating">
                                <input
                                  disabled
                                  required
                                  type="number"
                                  class="form-control"
                                  id="limit"
                                  name="limit"
                                  onChange={(e) => handlerInfoChange(e)}
                                  value={personalDetails?.limit}
                                  placeholder="Enter limit"
                                />
                                <label for="limit">Limit</label>
                              </div>
                            </div>
                            <div id="add_account_color" class="col-12 col-md-4">
                              <div class="form-floating">
                                <input
                                  required
                                  disabled
                                  type="number"
                                  class="form-control"
                                  id="minTicketSize"
                                  name="minTicketSize"
                                  onChange={(e) => handlerInfoChange(e)}
                                  value={personalDetails?.minTicketSize}
                                  placeholder="Enter limit"
                                />
                                <label for="minTicketSize">
                                  Min Ticket Size
                                </label>
                              </div>
                            </div>
                            <div id="add_account_color" class="col-12 col-md-4">
                              <div class="form-floating">
                                <input
                                  required
                                  disabled
                                  type="number"
                                  class="form-control"
                                  id="maxTicketSize"
                                  name="maxTicketSize"
                                  onChange={(e) => handlerInfoChange(e)}
                                  value={personalDetails?.maxTicketSize}
                                  placeholder="Enter limit"
                                />
                                <label for="maxTicketSize">
                                  Max Ticket Size
                                </label>
                              </div>
                            </div>

                            <div id="add_account_color" class="col-12 col-md-6">
                              <div class="form-floating">
                                <input
                                  required
                                  disabled
                                  type="number"
                                  class="form-control"
                                  id="minTicketSizePayout"
                                  name="minTicketSizePayout"
                                  onChange={(e) => handlerInfoChange(e)}
                                  value={personalDetails?.minTicketSizePayout}
                                  placeholder="Enter limit"
                                />
                                <label for="minTicketSizePayout">
                                  Min Ticket Size Payout
                                </label>
                              </div>
                            </div>

                            <div id="add_account_color" class="col-12 col-md-6">
                              <div class="form-floating">
                                <input
                                  required
                                  disabled
                                  type="number"
                                  class="form-control"
                                  id="maxTicketSizePayout"
                                  name="maxTicketSizePayout"
                                  onChange={(e) => handlerInfoChange(e)}
                                  value={personalDetails?.maxTicketSizePayout}
                                  placeholder="Enter limit"
                                />
                                <label for="maxTicketSizePayout">
                                  Max Ticket Size Payout
                                </label>
                              </div>
                            </div>

                            <div class="separator">
                              <span class="separator_text">Commercials</span>
                            </div>
                            <div id="add_account_color" class="col-12 col-md-3">
                              <div class="form-floating">
                                <input
                                  required
                                  disabled
                                  type="number"
                                  class="form-control"
                                  id="payinMdr"
                                  name="payinMdr"
                                  onChange={(e) => handlerInfoChange(e)}
                                  value={personalDetails?.payinMdr}
                                  placeholder="Enter payinMdr"
                                />
                                <label for="payinMdr">Pay in Mdr</label>
                              </div>
                            </div>
                            <div id="add_account_color" class="col-12 col-md-3">
                              <div class="form-floating">
                                <input
                                  required
                                  disabled
                                  type="number"
                                  class="form-control"
                                  id="payoutMdr"
                                  name="payoutMdr"
                                  onChange={(e) => handlerInfoChange(e)}
                                  value={personalDetails?.payoutMdr}
                                  placeholder="Enter payoutMdr"
                                />
                                <label for="payoutMdr">Pay out Mdr</label>
                              </div>
                            </div>
                            <div id="add_account_color" class="col-12 col-md-3">
                              <div class="form-floating">
                                <input
                                  required
                                  disabled
                                  type="number"
                                  class="form-control"
                                  id="payinReserve"
                                  name="payinReserve"
                                  onChange={(e) => handlerInfoChange(e)}
                                  value={personalDetails?.payinReserve}
                                  placeholder="Enter Pay in Reserve"
                                />
                                <label for="payinReserve">Pay in Reserve</label>
                              </div>
                            </div>
                            <div id="add_account_color" class="col-12 col-md-3">
                              <div class="form-floating">
                                <input
                                  required
                                  disabled
                                  type="number"
                                  class="form-control"
                                  id="reserveDuration"
                                  name="reserveDuration"
                                  onChange={(e) => handlerInfoChange(e)}
                                  value={personalDetails?.reserveDuration}
                                  placeholder="Enter Reserve Duration"
                                />
                                <label for="reserveDuration">
                                  Reserve duration
                                </label>
                              </div>
                            </div>
                            <div class="separator">
                              <span class="separator_text">
                                Settlement Details
                              </span>
                            </div>

                            <div id="add_account_color" class="col-12 col-md-4">
                              <div class="form-floating">
                                <input
                                  required
                                  disabled
                                  type="text"
                                  class="form-control"
                                  id="dtAdd"
                                  name="dtAdd"
                                  onChange={(e) => handlerInfoChange(e)}
                                  value={personalDetails?.dtAdd}
                                  placeholder="Enter DT Addr"
                                />
                                <label for="dtAdd">DT Add</label>
                              </div>
                            </div>
                            <div id="add_account_color" class="col-12 col-md-4">
                              <div class="form-floating">
                                <input
                                  required
                                  disabled
                                  type="text"
                                  class="form-control"
                                  id="dtNet"
                                  name="dtNet"
                                  onChange={(e) => handlerInfoChange(e)}
                                  value={personalDetails?.dtNet}
                                  placeholder="Enter DT Net"
                                />
                                <label for="dtNet">DT Net</label>
                              </div>
                            </div>
                            <div id="add_account_color" class="col-12 col-md-4">
                              <div class="form-floating">
                                <input
                                  required
                                  disabled
                                  type="number"
                                  class="form-control"
                                  id="dtMdr"
                                  name="dtMdr"
                                  onChange={(e) => handlerInfoChange(e)}
                                  value={personalDetails?.dtMdr}
                                  placeholder="Enter dtMdr"
                                />
                                <label for="dtMdr">DT Mdr</label>
                              </div>
                            </div>

                            <div class="col-12 col-md-6">
                              <input
                                disabled
                                type="checkbox"
                                name="api.enabled"
                                checked={personalDetails?.api?.enabled}
                                onChange={(e) =>
                                  handlerInfoChange(e, ENABLE, CHECKBOX)
                                }
                                id="customcheck1"
                              />
                              <label
                                style={{ marginLeft: "5px" }}
                                for="customcheck1"
                              >
                                Enable API
                              </label>
                            </div>

                            <div class="col-12 col-md-6">
                              <input
                                disabled
                                type="checkbox"
                                name="p2p.enabled"
                                checked={personalDetails?.p2p?.enabled || false}
                                onChange={(e) =>
                                  handlerInfoChange(e, ENABLE, CHECKBOX)
                                }
                              />
                              <label
                                style={{ marginLeft: "5px" }}
                                for="customcheck1"
                              >
                                Enable P2P
                              </label>
                            </div>
                            {personalDetails?.api?.enabled ? (
                              <div
                                id="add_account_color"
                                class="col-12 col-md-6"
                              >
                                <div class="form-floating">
                                  <input
                                    required
                                    disabled
                                    type="number"
                                    class="form-control"
                                    id="api.minTicketSize"
                                    name="api.minTicketSize"
                                    onChange={(e) =>
                                      handlerInfoChange(e, ENABLE)
                                    }
                                    value={personalDetails?.api?.minTicketSize}
                                    placeholder="Enter api minTicketSize"
                                  />
                                  <label for="api.minTicketSize">
                                    API Min TicketSize
                                  </label>
                                </div>
                              </div>
                            ) : (
                              <div
                                id="add_account_color"
                                class="col-12 col-md-6"
                              >
                                {" "}
                              </div>
                            )}
                            {personalDetails?.p2p?.enabled ? (
                              <div
                                id="add_account_color"
                                class="col-12 col-md-6"
                              >
                                <div class="form-floating">
                                  <input
                                    required
                                    disabled
                                    type="number"
                                    class="form-control"
                                    id="p2p.minTicketSize"
                                    name="p2p.minTicketSize"
                                    onChange={(e) =>
                                      handlerInfoChange(e, ENABLE)
                                    }
                                    value={personalDetails?.p2p?.minTicketSize}
                                    placeholder="Enter p2p.minTicketSize"
                                  />
                                  <label for="p2p.minTicketSize">
                                    P2P Min TicketSize
                                  </label>
                                </div>
                              </div>
                            ) : (
                              <div
                                id="add_account_color"
                                class="col-12 col-md-6"
                              ></div>
                            )}
                            {personalDetails?.api?.enabled ? (
                              <div
                                id="add_account_color"
                                class="col-12 col-md-6"
                              >
                                <div class="form-floating">
                                  <input
                                    required
                                    disabled
                                    type="number"
                                    class="form-control"
                                    id="api.maxTicketSize"
                                    name="api.maxTicketSize"
                                    onChange={(e) =>
                                      handlerInfoChange(e, ENABLE)
                                    }
                                    value={personalDetails?.api.maxTicketSize}
                                    placeholder="Enter api maxTicketSize"
                                  />
                                  <label for="api.maxTicketSize">
                                    API Max TicketSize
                                  </label>
                                </div>
                              </div>
                            ) : (
                              <div
                                id="add_account_color"
                                class="col-12 col-md-6"
                              >
                                {" "}
                              </div>
                            )}
                            {personalDetails?.p2p?.enabled ? (
                              <div
                                id="add_account_color"
                                class="col-12 col-md-6"
                              >
                                <div class="form-floating">
                                  <input
                                    required
                                    disabled
                                    type="number"
                                    class="form-control"
                                    id="p2p.maxTicketSize"
                                    name="p2p.maxTicketSize"
                                    onChange={(e) =>
                                      handlerInfoChange(e, ENABLE)
                                    }
                                    value={personalDetails?.p2p.maxTicketSize}
                                    placeholder="Enter p2p.maxTicketSize"
                                  />
                                  <label for="p2p.maxTicketSize">
                                    P2P Max TicketSize
                                  </label>
                                </div>
                              </div>
                            ) : (
                              <div
                                id="add_account_color"
                                class="col-12 col-md-6"
                              >
                                {" "}
                              </div>
                            )}

                            {personalDetails?.api?.enabled ? (
                              <div
                                id="add_account_color"
                                class="col-12 col-md-6"
                              >
                                <div class="form-floating">
                                  <input
                                    required
                                    disabled
                                    type="number"
                                    class="form-control"
                                    id="api.weight"
                                    name="api.weight"
                                    onChange={(e) =>
                                      handlerInfoChange(e, ENABLE)
                                    }
                                    value={personalDetails?.api.weight}
                                    placeholder="Enter api weight"
                                  />
                                  <label for="api.weight">API Weight</label>
                                </div>
                              </div>
                            ) : (
                              <div
                                id="add_account_color"
                                class="col-12 col-md-6"
                              >
                                {" "}
                              </div>
                            )}

                            {personalDetails?.p2p?.enabled ? (
                              <div
                                id="add_account_color"
                                class="col-12 col-md-6"
                              >
                                <div class="form-floating">
                                  <input
                                    required
                                    disabled
                                    type="number"
                                    class="form-control"
                                    id="p2p.weight"
                                    name="p2p.weight"
                                    onChange={(e) =>
                                      handlerInfoChange(e, ENABLE)
                                    }
                                    value={personalDetails?.p2p.weight}
                                    placeholder="Enter p2p.weight"
                                  />
                                  <label for="p2p.weight">P2P weight</label>
                                </div>
                              </div>
                            ) : (
                              <div
                                id="add_account_color"
                                class="col-12 col-md-6"
                              >
                                {" "}
                              </div>
                            )}
                            {/* maxTicketSize */}
                            <div class="separator">
                              <span class="separator_text"></span>
                            </div>
                            {isUpdate && (
                              <>
                                <div
                                  id="add_account_color"
                                  className="col-12 col-md-6"
                                >
                                  <div class="form-floating">
                                    <Select
                                      className="basic-multi-select form-control"
                                      styles={stylesofStyleWithColor}
                                      closeMenuOnSelect={true}
                                      components={{
                                        IndicatorsContainer: () => null,
                                        IndicatorSeparator: () => null,
                                      }}
                                      isMulti
                                      options={unAssignAccountOptions}
                                      value={unAssignAccountPayout}
                                      placeholder="N/A"
                                      isDisabled={true}
                                    />
                                    <label>
                                      Default Payout Acc List{" "}
                                      <IoIosArrowDropdown />{" "}
                                    </label>
                                  </div>
                                </div>
                                <div
                                  id="add_account_color"
                                  className="col-12 col-md-6"
                                >
                                  <div class="form-floating">
                                    <Select
                                      className="basic-multi-select form-control"
                                      styles={stylesofStyleWithColor}
                                      closeMenuOnSelect={true}
                                      components={{
                                        IndicatorsContainer: () => null,
                                        IndicatorSeparator: () => null,
                                      }}
                                      isMulti
                                      options={unAssignAccountOptions}
                                      value={unAssignAccountPayin}
                                      placeholder="N/A"
                                      isDisabled={true}
                                    />
                                    <label>
                                      Default Payin Acc List{" "}
                                      <IoIosArrowDropdown />{" "}
                                    </label>
                                  </div>
                                </div>
                                <div class="separator">
                                  <span class="separator_text"></span>
                                </div>
                                <div id="add_account_color" className="col-12">
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-end", // Ensures labels are on both sides
                                      // Centers the content vertically
                                    }}
                                  >
                                    <label htmlFor="customSwitch1">
                                      BY ACC NAME
                                    </label>

                                    <span
                                      style={{ marginLeft: "25px" }}
                                      className="form-check form-switch"
                                    >
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="customSwitch1"
                                        checked={isChecked} // Bind to state
                                        onChange={handleSwitchChange} // Handle switch change
                                      />
                                    </span>

                                    <label
                                      htmlFor="customSwitch1"
                                      // style={{ marginLeft: "10px" }}
                                    >
                                      BY BANKER ID
                                    </label>
                                  </div>
                                </div>

                                <div
                                  id="add_account_color"
                                  className="col-12 col-md-6"
                                >
                                  <div class="form-floating">
                                    <Select
                                      isDisabled={true}
                                      className="basic-multi-select form-control"
                                      styles={stylesofStyleWithColor}
                                      closeMenuOnSelect={true}
                                      components={{
                                        IndicatorsContainer: () => null,
                                        IndicatorSeparator: () => null,
                                      }}
                                      isMulti
                                      // options={payoutAssingnOptions}
                                      options={
                                        !isChecked
                                          ? payoutAssingnOptions
                                          : payoutAssignOptionsForBanker
                                      }
                                      onChange={merchantChangeHandlePayout}
                                      // value={assignAccountPayout}
                                      value={
                                        !isChecked
                                          ? assignAccountPayout
                                          : assignAccountBankerPayoutwithCount
                                      }
                                      placeholder="N/A"
                                      //isDisabled={isBanker && isUpdate}
                                    />
                                    <label>
                                      Assign Payout Acc List{" "}
                                      <IoIosArrowDropdown />{" "}
                                    </label>
                                  </div>
                                </div>

                                <div
                                  id="add_account_color"
                                  className="col-12 col-md-6"
                                >
                                  <div class="form-floating">
                                    <Select
                                      isDisabled={true}
                                      className="basic-multi-select form-control"
                                      styles={stylesofStyleWithColor}
                                      closeMenuOnSelect={true}
                                      components={{
                                        IndicatorsContainer: () => null,
                                        IndicatorSeparator: () => null,
                                      }}
                                      isMulti
                                      options={
                                        !isChecked
                                          ? payinAssingnOptions
                                          : payinAssignOptionsForBanker
                                      }
                                      onChange={merchantChangeHandlePayin}
                                      value={
                                        !isChecked
                                          ? assignAccountPayin
                                          : assignAccountBankerPayinwithCount
                                      }
                                      placeholder="N/A"
                                      //isDisabled={isBanker && isUpdate}
                                    />
                                    <label>
                                      Assign Payin Acc List{" "}
                                      <IoIosArrowDropdown />{" "}
                                    </label>
                                  </div>
                                </div>
                              </>
                            )}
                            <div class="separator">
                              <span class="separator_text"></span>
                            </div>
                            {isaddVpa && (
                              <>
                                <div
                                  id="add_account_color"
                                  class="col-12 col-md-3"
                                >
                                  <div class="form-floating">
                                    <input
                                      class="form-control"
                                      type="text"
                                      placeholder="Enter VPA"
                                      value={newVPA}
                                      onChange={(e) =>
                                        setNewVPA(e.target.value)
                                      }
                                    />
                                    <label for="payinMdr">Black List Vpa</label>
                                  </div>
                                </div>
                                <div
                                  id="add_account_color"
                                  class="col-12 col-md-3"
                                >
                                  <div class="form-floating">
                                    <input
                                      type="number"
                                      class="form-control"
                                      min="0"
                                      max="12"
                                      placeholder="Hours"
                                      value={expiryHours}
                                      onChange={(e) =>
                                        setExpiryHours(Number(e.target.value))
                                      }
                                    />
                                    <label for="payoutMdr">Hours</label>
                                  </div>
                                </div>
                                <div
                                  id="add_account_color"
                                  class="col-12 col-md-3"
                                >
                                  <div class="form-floating">
                                    <input
                                      type="number"
                                      class="form-control"
                                      min="0"
                                      max="59"
                                      step={15}
                                      placeholder="Minutes"
                                      value={expiryMinutes}
                                      onChange={(e) =>
                                        setExpiryMinutes(Number(e.target.value))
                                      }
                                    />
                                    <label for="payinReserve">Minutes</label>
                                  </div>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: 10,
                                  }}
                                  id="add_account_color"
                                  class="col-12 col-md-3"
                                >
                                  <Button
                                    variant="info"
                                    style={{
                                      background: "#000",
                                      color: "#fff",
                                      border: "none",
                                    }}
                                    size="sm"
                                    onClick={() => addBlacklistVPA()}
                                  >
                                    <IoIosAddCircleOutline
                                      size={25}
                                      style={{ color: "#fff" }}
                                    />
                                  </Button>
                                  <Button
                                    variant="danger"
                                    style={{ color: "#fff" }}
                                    size="sm"
                                    onClick={() => setIsAddVpa(false)}
                                  >
                                    <IoArrowBackCircleOutline
                                      size={25}
                                      style={{ color: "#fff" }}
                                    />
                                  </Button>
                                </div>
                              </>
                            )}
                            {!isaddVpa && (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                                // id="add_account_color"
                                class="col-12"
                              >
                                <Button
                                  variant="info"
                                  style={{ color: "#fff" }}
                                  size="sm"
                                  onClick={() => setIsAddVpa(true)}
                                >
                                  Blacklist VPA
                                </Button>
                              </div>
                            )}
                            <div class="separator">
                              <span class="separator_text"></span>
                            </div>
                            <div id="add_account_color" class="col-12 ">
                              <div className="mt-4">
                                <div className="container-fluid">
                                  <div className="tab-content" id="mobiletab">
                                    <div
                                      className="tab-pane fade show active"
                                      id="nav-mobi"
                                      role="tabpanel"
                                      aria-labelledby="mobile-tab"
                                    >
                                      <div className="txn-list" id="recntxn">
                                        <>
                                          {blacklist?.length === 0 ? (
                                            <h6
                                              style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                fontSize: "17px",
                                                fontWeight: 800,
                                                marginBottom: "20px",
                                              }}
                                            >
                                              No Black List Account Found
                                            </h6>
                                          ) : (
                                            blacklist?.map((data) => (
                                              <div
                                                className="txn-item"
                                                key={data.id}
                                              >
                                                <div
                                                  className="txn-head"
                                                  id="txnhead1"
                                                >
                                                  <div
                                                    className="collapsed"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target="#txn1"
                                                    aria-expanded="false"
                                                    aria-controls="txn1"
                                                  >
                                                    <div
                                                      className={`txncard ${
                                                        moment(
                                                          data.expireOn
                                                        ).isBefore(moment())
                                                          ? "failed rdbg"
                                                          : "success grbg"
                                                      }`}
                                                    >
                                                      <div className="row">
                                                        <div className="col-12 col-md-2">
                                                          <div className="txntxt">
                                                            <h6>{data?.vpa}</h6>
                                                          </div>
                                                        </div>
                                                        <div className="col-12 col-md-5">
                                                          <div className="txntxt">
                                                            <h6>
                                                              {data?.byUser}
                                                            </h6>
                                                          </div>
                                                        </div>
                                                        <div className="col-12 col-md-2">
                                                          <div className="txntxt">
                                                            <h6>
                                                              {data?.addedOn}
                                                            </h6>
                                                          </div>
                                                        </div>
                                                        <div className="col-12 col-md-2">
                                                          <div className="txntxt">
                                                            <h6>
                                                              {data?.expireOn}
                                                            </h6>
                                                          </div>
                                                        </div>
                                                        <div className="col-12 col-md-1">
                                                          <div className="txntxt">
                                                            {moment(
                                                              data?.expireOn
                                                            ).isAfter(
                                                              moment()
                                                            ) && (
                                                              <TiDeleteOutline
                                                                onClick={() =>
                                                                  expireVPA(
                                                                    data.vpa
                                                                  )
                                                                }
                                                                style={{
                                                                  color:
                                                                    dangerColor,
                                                                  cursor:
                                                                    "pointer",
                                                                }}
                                                                size={25}
                                                              />
                                                            )}
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            ))
                                          )}
                                        </>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="col-12 d-flex flex-column flex-md-row justify-content-between align-items-center">
                              <button
                                onClick={goback}
                                type="button"
                                className="btn btn-secondary w-30 w-md-auto mb-2 mb-md-0"
                              >
                                Cancel
                              </button>

                              <button
                                type="submit"
                                className="btn btn-primary w-25 w-md-auto mb-2 mb-md-0"
                              >
                                Submit{" "}
                                <span style={{ marginRight: "20px" }}></span>
                                {Array.isArray(backlistCount) &&
                                  backlistCount.length > 0 && (
                                    <BubbleWithNumber
                                      number={backlistCount.length}
                                      color={"blue"}
                                    />
                                  )}
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
